// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `app-menu-modal {
  position: relative;
  text-transform: capitalize;
}

.header-btn ion-icon {
  width: 19px;
  right: 5px;
  top: 10px;
  position: absolute;
}

.wrapper {
  color: var(--color-black);
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.wrapper .center-section {
  padding: 30px 15px 15px 20px;
}
.wrapper .header-section {
  padding: 30px 15px 15px 20px;
}

.separator {
  width: 100%;
  margin: 16px 0;
}

ion-icon {
  width: 32px;
  margin-right: 3px;
  padding: 4px;
  border-radius: 0;
}

.version {
  opacity: 0.3;
  font-size: x-small;
  color: var(--color-black);
}

ion-row {
  align-items: center;
  padding: 2px;
  cursor: pointer;
}

.name {
  margin: 0px;
  font-size: 26px;
  text-transform: uppercase;
  color: var(--color-black);
  font-family: AppFontMedium, sans-serif;
}

.email {
  margin: 0px;
  font-size: 14px;
  margin-top: 2px;
  font-family: AppFont, sans-serif;
  color: var(--color-black);
  padding-bottom: 15px;
}

a {
  text-decoration: none;
  color: black;
}

ion-button {
  color: white;
  --background: rgba(255, 255, 255, 0.3);
  backdrop-filter: blur(4px);
}

.lang-row {
  font-size: 20px;
  font-family: AppFont, sans-serif;
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
}

ion-col {
  font-size: 20px;
  color: var(--color-black);
}

.selected {
  opacity: 1 !important;
}

.lang-title {
  max-width: 90%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin: 0px;
}

ion-icon {
  zoom: 1.1;
}

ion-row {
  margin-top: 6px;
}

.header-wrap {
  margin: 10px;
}

.header-wrap-block {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid var(--color-black);
}

.selected {
  opacity: 1 !important;
}

.version {
  position: absolute;
  bottom: 3px;
  right: 10px;
  color: var(--color-black);
}

.footer-lang {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}
.footer-lang div:first-child {
  margin-left: 20px;
}
.footer-lang div {
  margin: 0px 5px;
  text-align: center;
  width: 48%;
  --border-color: var(--ion-color-primary);
  border: 2px solid var(--ion-color-primary);
  background: transparent;
  border-radius: 50px;
  overflow: hidden;
  padding: 12px 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
}
.footer-lang div span {
  text-transform: uppercase;
  font-size: 14px !important;
  color: var(--ion-color-primary);
}
.footer-lang div.selected {
  background: var(--ion-color-primary);
  border: none;
}
.footer-lang div.selected span {
  color: white;
}

.footer-block {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
}
.footer-block .lang-block {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.footer-block .lang-block .lang-item {
  padding: 5px 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 26px;
  margin-right: 10px;
  transition: background-color 0.3s ease;
  cursor: pointer;
  border: 1px solid var(--color-black);
  background: white;
}
.footer-block .lang-block .lang-item ion-icon {
  width: 18px;
  height: 18px;
  padding: 0px;
  opacity: 0.5;
  transition: opacity 0.3s ease-in-out;
}
.footer-block .lang-block .lang-item h3 {
  font-family: AppFont, sans-serif;
  font-size: 16px;
  color: var(--color-black);
  transition: color 0.3s ease;
}
.footer-block .lang-block .lang-item.selected {
  background: var(--ion-color-primary);
}
.footer-block .lang-block .lang-item.selected ion-icon {
  opacity: 1;
}
.footer-block .lang-block .lang-item.selected h3 {
  color: white;
}
.footer-block .logout {
  zoom: 1.5;
  margin: 0px;
}

.footer-section-desktop {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px;
  border-top: 1px solid var(--color-black);
}
.footer-section-desktop .left-section p {
  font-size: 12px;
  font-family: AppFontMedium;
  padding-bottom: 10px;
  cursor: pointer;
}
.footer-section-desktop .left-section p:hover {
  color: var(--ion-color-primary);
}
.footer-section-desktop .right-section .lang-block {
  display: flex;
  align-items: center;
}
.footer-section-desktop .right-section .lang-block .vertical-line {
  margin: 0px 20px;
  width: 1px;
  height: 20px;
  background: var(--color-black);
}
.footer-section-desktop .right-section .lang-block h3 {
  font-size: 16px;
  font-family: AppFontMedium;
  cursor: pointer;
}
.footer-section-desktop .right-section .lang-block .lang-item.selected h3 {
  font-family: AppFontBold;
}

@media (min-width: 991px) {
  .block-items {
    height: 200px;
  }
}

.logout-block {
  width: -moz-fit-content;
  width: fit-content;
  padding: 10px;
  border: 1px solid var(--color-black);
  border-radius: 26px;
  text-transform: uppercase;
  font-size: 14px;
  cursor: pointer;
  margin-top: 20px;
  margin-left: 20px;
  min-width: 150px;
  text-align: center;
}

ion-row:hover ion-col {
  color: var(--ion-color-primary);
}`, "",{"version":3,"sources":["webpack://./src/app/components/menu-modal/menu-modal.component.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AACA;EAEE,kBAAA;EACA,0BAAA;AADF;;AAKE;EACE,WAAA;EACA,UAAA;EACA,SAAA;EACA,kBAAA;AAFJ;;AAKA;EACE,yBAAA;EAEA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;AAHF;AAIE;EACE,4BAAA;AAFJ;AAIE;EACE,4BAAA;AAFJ;;AAMA;EACE,WAAA;EACA,cAAA;AAHF;;AAMA;EACE,WAAA;EACA,iBAAA;EACA,YAAA;EACA,gBAAA;AAHF;;AAMA;EACE,YAAA;EACA,kBAAA;EACA,yBAAA;AAHF;;AAMA;EACE,mBAAA;EACA,YAAA;EACA,eAAA;AAHF;;AAMA;EACE,WAAA;EAEA,eAAA;EACA,yBAAA;EACA,yBAAA;EACA,sCAAA;AAJF;;AAMA;EACE,WAAA;EACA,eAAA;EACA,eAAA;EACA,gCAAA;EACA,yBAAA;EACA,oBAAA;AAHF;;AAMA;EACE,qBAAA;EACA,YAAA;AAHF;;AAOA;EACE,YAAA;EACA,sCAAA;EACA,0BAAA;AAJF;;AAMA;EACE,eAAA;EACA,gCAAA;EACA,aAAA;EACA,mBAAA;EACA,iBAAA;AAHF;;AAKA;EACE,eAAA;EACA,yBAAA;AAFF;;AAKA;EACE,qBAAA;AAFF;;AAIA;EACE,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,WAAA;AADF;;AAGA;EACE,SAAA;AAAF;;AAGA;EACE,eAAA;AAAF;;AAEA;EACE,YAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,2CAAA;AACF;;AAEA;EACE,qBAAA;AACF;;AAEA;EACE,kBAAA;EACA,WAAA;EACA,WAAA;EACA,yBAAA;AACF;;AAEA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,WAAA;AACF;AACE;EACE,iBAAA;AACJ;AACE;EACE,eAAA;EACA,kBAAA;EACA,UAAA;EACA,wCAAA;EACA,0CAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;AACJ;AAAM;EACE,yBAAA;EACA,0BAAA;EACA,+BAAA;AAER;AAEM;EAIE,oCAAA;EACA,YAAA;AAHR;AADQ;EACE,YAAA;AAGV;;AAIA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;AADF;AAEE;EACE,aAAA;EACA,2BAAA;EACA,mBAAA;AAAJ;AACI;EACE,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,sCAAA;EACA,eAAA;EACA,oCAAA;EAQA,iBAAA;AANN;AADM;EACE,WAAA;EACA,YAAA;EACA,YAAA;EACA,YAAA;EACA,oCAAA;AAGR;AAAM;EACE,gCAAA;EACA,eAAA;EACA,yBAAA;EAEA,2BAAA;AACR;AAGM;EACE,oCAAA;AADR;AAEQ;EACE,UAAA;AAAV;AAEQ;EACE,YAAA;AAAV;AAME;EACE,SAAA;EACA,WAAA;AAJJ;;AAOA;EAEE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,aAAA;EACA,wCAAA;AALF;AAOI;EACE,eAAA;EACA,0BAAA;EACA,oBAAA;EACA,eAAA;AALN;AAOI;EACE,+BAAA;AALN;AASI;EACE,aAAA;EACA,mBAAA;AAPN;AAQM;EACE,gBAAA;EACA,UAAA;EACA,YAAA;EACA,8BAAA;AANR;AAQM;EACE,eAAA;EACA,0BAAA;EACA,eAAA;AANR;AAUU;EACE,wBAAA;AARZ;;AC5PE;ED4QF;IAEI,aAAA;EAbF;AACF;;AAeA;EACE,uBAAA;EAAA,kBAAA;EACA,aAAA;EACA,oCAAA;EACA,mBAAA;EACA,yBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;AAZF;;AAgBI;EACE,+BAAA;AAbN","sourcesContent":["@import \"../../../theme/mixins\";\napp-menu-modal {\n\n  position: relative;\n  text-transform: capitalize;\n}\n.header-btn {\n\n  ion-icon {\n    width: 19px;\n    right: 5px ;\n    top: 10px;\n    position: absolute;\n  }\n}\n.wrapper {\n  color: var(--color-black);\n\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  .center-section {\n    padding: 30px 15px 15px 20px;\n  }\n  .header-section {\n    padding: 30px 15px 15px 20px;\n  }\n}\n\n.separator {\n  width: 100%;\n  margin: 16px 0;\n}\n\nion-icon {\n  width: 32px;\n  margin-right: 3px;\n  padding: 4px;\n  border-radius: 0;\n}\n\n.version {\n  opacity: 0.3;\n  font-size: x-small;\n  color: var(--color-black);\n}\n\nion-row {\n  align-items: center;\n  padding: 2px;\n  cursor: pointer;\n}\n\n.name {\n  margin: 0px;\n\n  font-size: 26px;\n  text-transform: uppercase;\n  color: var(--color-black);\n  font-family: AppFontMedium, sans-serif;\n}\n.email{\n  margin: 0px;\n  font-size: 14px;\n  margin-top: 2px;\n  font-family: AppFont, sans-serif;\n  color: var(--color-black);\n  padding-bottom: 15px;\n}\n\na {\n  text-decoration: none;\n  color: black;\n}\n\n\nion-button {\n  color: white;\n  --background: rgba(255, 255, 255, 0.3);\n  backdrop-filter: blur(4px);;\n}\n.lang-row{\n  font-size: 20px;\n  font-family: AppFont, sans-serif;\n  display: flex;\n  align-items: center;\n  flex-wrap: nowrap;\n}\nion-col {\n  font-size: 20px;\n  color: var(--color-black);\n}\n\n.selected{\n  opacity: 1 !important;\n}\n.lang-title{\n  max-width: 90%;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  margin: 0px;\n}\nion-icon {\n  zoom: 1.1;\n}\n\nion-row{\n  margin-top: 6px;\n}\n.header-wrap{\n  margin: 10px;\n}\n\n.header-wrap-block {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  border-bottom: 1px solid var(--color-black);\n \n}\n.selected{\n  opacity: 1 !important;\n}\n\n.version {\n  position: absolute;\n  bottom: 3px;\n  right: 10px;\n  color: var(--color-black);\n}\n\n.footer-lang{\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  \n  div:first-child {\n    margin-left: 20px;\n  }\n  div {\n    margin: 0px 5px;\n    text-align: center;\n    width: 48%;\n    --border-color: var(--ion-color-primary);\n    border: 2px solid  var(--ion-color-primary);\n    background: transparent;\n    border-radius: 50px;\n    overflow: hidden;\n    padding: 12px 30px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-weight: bold;\n      span {\n        text-transform: uppercase;\n        font-size: 14px !important;\n        color:  var(--ion-color-primary);\n      }\n    }\n    div {\n      &.selected {\n        span {\n          color: white;\n        }\n        background:  var(--ion-color-primary);\n        border: none;\n      }\n    }\n}\n.footer-block {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 30px;\n  .lang-block {\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    .lang-item {\n      padding: 5px 25px;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      border-radius: 26px;\n      margin-right: 10px;\n      transition: background-color 0.3s ease; \n      cursor: pointer;\n      border: 1px solid var(--color-black);\n      ion-icon {\n        width: 18px;\n        height: 18px;\n        padding: 0px;\n        opacity: 0.5;\n        transition: opacity 0.3s ease-in-out;\n      }\n      background: white;\n      h3 {\n        font-family: AppFont, sans-serif;\n        font-size: 16px;\n        color: var(--color-black);\n\n        transition: color 0.3s ease; \n\n      }\n\n      &.selected {\n        background: var(--ion-color-primary);\n        ion-icon {\n          opacity: 1;\n        }\n        h3 {\n          color: white;\n        }\n      }\n\n    }\n  }\n  .logout {\n    zoom: 1.5;\n    margin: 0px;\n  }\n}\n.footer-section-desktop {\n\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 20px;\n  border-top: 1px solid var(--color-black);\n  .left-section {\n    p {\n      font-size: 12px;\n      font-family: AppFontMedium;\n      padding-bottom: 10px;\n      cursor: pointer;\n    }\n    p:hover {\n      color: var(--ion-color-primary);\n    }\n  }\n  .right-section {\n    .lang-block {\n      display: flex;\n      align-items: center;\n      .vertical-line {\n        margin: 0px 20px;\n        width: 1px;\n        height: 20px;\n        background: var(--color-black);\n      }\n      h3 {\n        font-size: 16px;\n        font-family: AppFontMedium;\n        cursor: pointer;\n      }\n      .lang-item{\n        &.selected {\n          h3 {\n            font-family: AppFontBold;\n          }\n\n        }\n      }\n    }\n  }\n}\n.block-items {\n  @include desktop {\n    height: 200px;\n  }\n}\n.logout-block {\n  width: fit-content;\n  padding: 10px;\n  border: 1px solid var(--color-black);\n  border-radius: 26px;\n  text-transform: uppercase;\n  font-size: 14px;\n  cursor: pointer;\n  margin-top: 20px;\n  margin-left: 20px;\n  min-width: 150px;\n  text-align: center;\n}\nion-row {\n  &:hover {\n    ion-col {\n      color: var(--ion-color-primary);\n    }\n  }\n}","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
